// Meta (Facebook) Pixel loader + safe event helpers.
//
// Paste your Pixel ID into META_PIXEL_ID below. While it is an empty string the
// pixel does NOT load at all — no script, no network calls, no fbq — so the app
// behaves exactly as before. This keeps it host-agnostic (works the same on
// Vercel or anywhere) with no environment variables to configure.
const META_PIXEL_ID = "143454496270616"; // paste pixel ID here

let loaded = false;

// Load + initialize the Meta Pixel once. No-op when META_PIXEL_ID is empty.
export function initMetaPixel() {
  if (loaded) return;
  if (!META_PIXEL_ID) return; // empty string → don't load the pixel at all
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // Standard Meta Pixel bootstrap snippet.
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');
  loaded = true;
}

// Fire a Lead conversion event — only if the pixel actually loaded.
export function trackLead() {
  if (!loaded) return;
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq('track', 'Lead');
}
